// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"5f043cc937ead17849b7","263":"ddb86b0c97eea7252262","791":"7201b8116363cb347254"}[chunkId] + ".js";
};